import React, {lazy, Suspense} from 'react'
import {Switch, Route} from 'react-router-dom'
import {Typography} from 'antd'
import typo, { MESSAGE } from "../../constants/dictionaries";
import { groupFunctionsCode, functionsCode } from "../../constants/constant";
const {Title} = Typography;

// Components
const HienTrangMT = lazy(() => import('./HienTrangMoiTruong'));
const TramQT = lazy(() => import('./TramQuanTrac'));
export default ({match}) => {
  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/Bao-cao-dinh-ky`} render={(props)=> <HienTrangMT {...props} />}/>
        <Route exact path={`${match.path}/tram-quan-trac`} render={(props)=> <TramQT {...props} />}/>
      </Switch>
    </Suspense>
  )
}